
import {
  AnnualTaxSearchFormValues,
  AnnualTaxEditFormValues,
  AnnualTaxDetailFormValues,
} from "./types";


/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - ANNUAL TAX - SEARCH
---------------------------------------------------------------------------------------------*/
export const initialAnnualTaxSearchForm: AnnualTaxSearchFormValues =
  {
    search: "",
  };

/*-------------------------------------------------------------------------------------------
CALCULATION SETTING - ANNUAL TAX - EDIT
---------------------------------------------------------------------------------------------*/

export const initialAnnualTaxEditForm: AnnualTaxEditFormValues =
  {
    fromKw: null,
    toKw: null,
    price: null,
  };

/*-------------------------------------------------------------------------------------------
    CALCULATION SETTING - ANNUAL TAX - DETAIL
---------------------------------------------------------------------------------------------*/

export const initialAnnualTaxDetailForm: AnnualTaxDetailFormValues =
  {
    id: null,
    fromKw: null,
    toKw: null,
    price: null,
  };

